import React from "react";
import PropTypes from "prop-types";
import s from "./GlobalFooter.css";

const GlobalFooter = ({ t }) => (
  <footer>
    <h1 className={s.brand}>{t("GlobalFooter/headings/heading")}</h1>

    <nav>
      <a href="/destinations">{t("GlobalFooter/headings/destinations")}</a>
      <a href="/shop">{t("GlobalFooter/headings/shop")}</a>
      <a href="/community">{t("GlobalFooter/headings/community")}</a>
      <a href="/interests">{t("GlobalFooter/headings/interests")}</a>
      <a href="/travel-booking">{t("GlobalFooter/headings/travel-booking")}</a>
      <a href="/subscribe">{t("GlobalFooter/headings/subscribe")}</a>
    </nav>
  </footer>
);

GlobalFooter.propTypes = {
  // react-i18next translation function
  t: PropTypes.func.isRequired,
};

export default GlobalFooter;
